import { useEffect, useState } from 'react'
import { useDispatch } from 'react-redux'
import { useTranslation } from 'react-i18next'
import { isEmpty } from 'lodash'
import { toggleNoti, toggleError } from 'config/slice/message'
import {
    TYPE_EMAIL
} from 'config/const/type'
import {
    KEY_BTN_FORGETPWD,
    KEY_ERROR_EMAIL_NOT_FILL,
    KEY_ERROR_SENT_FAILED,
    KEY_NOTI_SENT,
    KEY_TEXT_BTN_LOGIN,
    KEY_TEXT_FORGETPWD_MODAL_TITLE,
    KEY_TEXT_IPT_EMAIL,
    MODULE_FORGET_PWD,
} from 'config/const/locale'
import { useForgetPwdMutation } from 'config/api/waV1_user'
import { STATUS_API_SENT } from 'config/const/global'



export default function ForgetPWD() {

    const [iptValue, setIptValue] = useState({
        [TYPE_EMAIL]: ''
    }) // inputs' value
    const [sent, setSent] = useState(false)
    const dispatch = useDispatch() // redux method manipulating the state
    const { t } = useTranslation(MODULE_FORGET_PWD) // i18n hook, i18n.changeLanguage('en') method to change language
    const [forgetPwdFn] = useForgetPwdMutation()

    /**
     * handle inputs relating to login
     * @param {String} type input's type and key
     */
    const iptHandler = (type) => (e) => setIptValue(prev => ({ ...prev, [type]: e.target.value }))

    // login btn handler, data checking and msg noticing
    const forgetPwdHandler = () => {

        if (isEmpty(iptValue[TYPE_EMAIL])) { // check account input's value, return if empty
            dispatch(toggleError({
                indicator: true,
                msg: t(KEY_ERROR_EMAIL_NOT_FILL)
            }))
            return
        }

        setSent(true)
        window.forgetTimer = setTimeout(() => {
            setSent(false)
        }, 1000 * 10);
        forgetPwdFn(iptValue[TYPE_EMAIL])
            .then(res => {
                if (res.data?.data?.status == STATUS_API_SENT) {
                    dispatch(toggleNoti({
                        indicator: true,
                        msg: t(KEY_NOTI_SENT)
                    }))
                } else {
                    dispatch(toggleError({
                        indicator: true,
                        msg: t(KEY_ERROR_SENT_FAILED)
                    }))
                }
            })
            .catch(reason => {
                dispatch(toggleError({
                    indicator: true,
                    msg: t(KEY_ERROR_SENT_FAILED)
                }))
            })
    }

    useEffect(() => {
        if (!sent) {
            clearTimeout(window?.forgetTimer)
        }
    }, [sent])

    return (
        <div className='wa-fullscreen wa-bg-login'>

            <div className="login-box position-fixed start-50 top-50 translate-middle">
                <div className="card wa-light-blue wa-rounded-2rem overflow-hidden">
                    <div className="card-header">
                        <div className="link-dark text-center link-offset-2 link-opacity-100 link-opacity-50-hover text-white wa-light-blue">
                            <h1 className='fs-3 p-3'>
                                {t(KEY_TEXT_FORGETPWD_MODAL_TITLE)}
                            </h1>
                        </div>
                    </div>
                    <div className="card-body login-card-body">
                        <form>
                            <div className="input-group mb-1">
                                <div className="form-floating col-11 p-0 wa-h-5rem">
                                    <input id="loginEmail" type="email" className="form-control wa-h-5rem fs-4 ps-4 border-secondary wa-rounded-start" placeholder="" onChange={iptHandler(TYPE_EMAIL)} />
                                    <label htmlFor="loginEmail" className='fs-4 ps-4'>{t(KEY_TEXT_IPT_EMAIL)}</label>
                                </div>
                                <div className="input-group-text col-1 border-secondary wa-rounded-end">
                                    {/* <span className="bi bi-envelope"></span> */}
                                </div>
                            </div>
                            {/* <!--begin::Row--> */}
                            <div className="row my-4">
                                <div className="col-12">
                                    <div className="d-grid gap-2" onClick={sent ? () => { } : forgetPwdHandler}>
                                        <a className={sent ? "btn wa-light-blue text-white p-4 fs-4 rounded rounded-pill wa-btn-disable" : "btn wa-light-blue text-white p-4 fs-4 rounded rounded-pill"}>{t(KEY_BTN_FORGETPWD)}</a>
                                        <a className={"btn wa-light-blue text-white p-4 fs-4 rounded rounded-pill"}>{t(KEY_TEXT_BTN_LOGIN)}</a>
                                    </div>
                                </div>
                                {/* <!-- /.col --> */}
                            </div>
                            {/* <!--end::Row--> */}
                        </form>
                    </div>
                    {/* <!-- /.login-card-body --> */}
                </div>
            </div>
        </div>
    )
}
